import PropTypes from 'prop-types';
import React from 'react';
import TaxStrategyInternalNoteLayout
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyTabs/TaxStrategyInternalNoteLayout';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { FDBodyText, FDStack, FDTitleText } from '@facet-wealth/design';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import TaxStrategyMetaOverrideSet
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyMetaOverrideSet';

const TaxStrategyInternalNotes = ({ onSubmit }) => {
  const { activeTabResource } = useTabContentContext();
  return (
    <FDStack direction={'column'} spacing={8} paddingY={5}>
      <FDStack direction={'column'} spacing={2}>
        <FDTitleText color={'textSecondary'} size={'lg'} value={'Internal Summary'} />
        <FDBodyText size={'md'} value={'Provide a quick summary of your thoughts for the team.'} />
      </FDStack>
      <FDStack direction={'column'} spacing={4}>
        <MetaCollectionRenderer
          collection={activeTabResource.attr('notes')}
          layout={TaxStrategyInternalNoteLayout}
          metaOverrideSet={TaxStrategyMetaOverrideSet}
          LayoutProps={{
            onSubmit,
          }}
        />
      </FDStack>
    </FDStack>
  );
};

TaxStrategyInternalNotes.defaultProps = {
};

TaxStrategyInternalNotes.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default TaxStrategyInternalNotes;
